import React from 'react';
import moment from 'moment/moment';
import { Nullable } from 'global';
import { DoneAll } from '@mui/icons-material';
import { DateFormats } from 'constants/common';
import { lightGreen } from '@mui/material/colors';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

import { Stage } from '../../api';

interface Props {
  stage: Nullable<Stage>;
}

export const CompletedBadge = ({ stage }: Props) => {
  return (
    <Tooltip
      arrow
      placement="left"
      title={
        <Stack>
          <Typography>Completed by {stage?.fieldValues?.completedBy?.fullName}</Typography>
          <Typography>
            on {moment(stage?.fieldValues?.completedDateTime).format(DateFormats.DateTimeShort24Hour)}
          </Typography>
        </Stack>
      }
    >
      <Box
        sx={{
          gap: '0.25rem',
          display: 'flex',
          cursor: 'default',
          padding: '2px 8px',
          borderRadius: '4px',
          alignItems: 'center',
          backgroundColor: lightGreen[300],
        }}
      >
        <DoneAll color="success" />
        <Typography color="success">Completed</Typography>
      </Box>
    </Tooltip>
  );
};
